import { render } from "./CustomInput.vue?vue&type=template&id=48de44c5&scoped=true"
import script from "./CustomInput.vue?vue&type=script&lang=js"
export * from "./CustomInput.vue?vue&type=script&lang=js"

import "./CustomInput.vue?vue&type=style&index=0&id=48de44c5&lang=css"
import "./CustomInput.vue?vue&type=style&index=1&id=48de44c5&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48de44c5"]])

export default __exports__